import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'extract'
})
export class ExtractPipe implements PipeTransform {
    transform(values: any, prop: string | any, ...args: any[]): string {
        if (Array.isArray(values)) {
            if (prop instanceof Function) {
                values = values.map(prop);
            } else {
                values = !!prop ? values.map((v) => v[prop] || v) : values;
            }

            if (!args.length) {
                return values;
            }

            return values.join(args[0] || ',');
        } else if (values && !!prop && values.hasOwnProperty(prop)) {
            return values[prop];
        } else if (!!prop && typeof prop === 'function') {
            if (args.length > 0) {
                return prop.apply(null, args)(values);
            } else {
                return prop(values);
            }
        }

        return values;
    }
}
